import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import { validation, withCapture, _ } from 'utils'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { showNotification } from 'features/notifications'
import { useDispatch } from 'react-redux'
import { showErrorNotification } from 'features/notifications/notificationsSlice'
import FullPageLoading from 'components/FullPageLoading'
import FormTabs from 'features/forms/FormTabs'
import { useEventSlug, useSlug } from 'hooks'
import routes from 'routes'
import Settings from './tabs/Settings'
import { createMeeting } from '../graphql/mutation'

export const meetingValidation = Yup.object().shape({
    title: Yup.string().required(),
    startsAt: Yup.date().required(),
    endsAt: validation.endsAt,
    capacity: Yup.number().integer().required(),
})
const initialValues = {
    title: '',
    startsAt: '',
    endsAt: '',
    capacity: 25,
}

const CreateMeeting = () => {
    const dispatch = useDispatch()
    const location = useLocation<{ spaceId: number }>()
    const history = useHistory()
    const eventSlug = useEventSlug()
    const meetingSlug = useSlug('meetingSlug')
    const [isUploading, setIsUploading] = useState(false)
    const spaceId = location.state?.spaceId
    const handleSubmit = withCapture(async (values) => {
        setIsUploading(true)
        const response = await createMeeting({ ...values, spaceId })
        setIsUploading(false)
        if (!response.data || response.errors.length) {
            dispatch(showErrorNotification(response.errors))
            return
        }
        dispatch(showNotification({
            type: 'success',
            body: _('form.notification.update_success'),
        }))
        // After submitting successfully, redirect to edit page
        const meetingId = response.data?.createMeeting?.id
        history.push(routes.updateMeeting.getPath({
            eventSlug, meetingSlug, meetingId
        }), { spaceId })
    })

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={meetingValidation}
            onSubmit={handleSubmit}
        >
            <>
                <FormTabs
                    tabs={[
                        { id: 'settings', name: _('meeting.tabs.settings'), Component: Settings },
                    ]}
                />
                {isUploading && <FullPageLoading isAbsolute />}
            </>
        </Formik>
    )
}

export default CreateMeeting
